import { render, staticRenderFns } from "./TemplateProductVariantsModal.vue?vue&type=template&id=2c9ca226&scoped=true"
import script from "./TemplateProductVariantsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductVariantsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TemplateProductVariantsModal.vue?vue&type=style&index=0&id=2c9ca226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ca226",
  null
  
)

export default component.exports